import server from '@/axios/server.js';

export const getJsapiTicket = () => server.get('/xiaozi-xmo/wireless/saas/employee/wechat/jsapi/ticket');
